import React, { useCallback, useContext, useState } from 'react';
import DealerAd from '../..';
import { useWixDealerListener } from '../../DealerAdIframe';
import ddt from '@wix/da-ddt';
import cn from 'classnames';
import Close from '@wix/da-ds/pkg/Icons/16x16/Close';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import axios from 'axios';
import { yieldToMainAsync } from '@wix/da-hooks/pkg/yieldToMain';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';

import s from './Adhesion.scss';

export interface Props {
  realEstateId: string;
}

const AdhesionAdUnit: React.FC<Props> = ({ realEstateId }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [passedOffer, setPassedOffer] = useState<any>(undefined);
  const [isHidden, setIsHidden] = useState(false);
  const isMounted = useIsMounted();
  const { biClientIdSigned, biClientId, useridUuid } =
    useContext(SessionContext);

  const handler = useCallback(data => {
    ddt.log('dealer', 'Got command from iframe2', data);
    switch (data.command) {
      case 'show-adhesion':
        setIsVisible(true);
        setPassedOffer(data.data);
        break;

      default:
        break;
    }
  }, []);

  useWixDealerListener(realEstateId, handler);

  const closeHandler = useCallback(async () => {
    await yieldToMainAsync();
    setIsHidden(true);
    await yieldToMainAsync();
    const userId = useridUuid === '' ? biClientId : useridUuid;
    const params = {
      realEstateId,
      offerId: passedOffer.offerGuid,
      userId: userId,
      targetAccountId: userId,
      loggedInAccountId: userId,
    };
    if (passedOffer) {
      // https://bo.wix.com/wix-docs/rest/internal-tools/dealer-offer-events/report-event
      axios
        .create()
        .post(
          `https://www.wix.com/_api/dealer-offer-events-service/proxy/v1/dealer-offer-events/${passedOffer?.offerGuid}`,
          {
            deviantArtUserId: biClientIdSigned,
            event: {
              type: 'CLOSE',
              ...params,
            },
          },
          {
            headers: {},
          }
        )
        .catch(e => {});
      // https://bo.wix.com/wix-docs/rest/internal-tools/dealer-offer-events/report-event
      axios
        .create()
        .post(
          `https://www.wix.com/_api/dealer-offer-events-service/proxy/v1/dealer-offer-events/${passedOffer?.offerGuid}`,
          {
            deviantArtUserId: biClientIdSigned,
            event: {
              type: 'SHOW_LATER',
              ...params,
            },
          },
          {
            headers: {},
          }
        )
        .catch(e => {});
    }
  }, [biClientId, biClientIdSigned, passedOffer, realEstateId, useridUuid]);

  if (isHidden || !isMounted) {
    return null;
  }

  return (
    <ErrorBoundary debugComponent="AdhesionAdUnit">
      <div className={cn(s['root'], isVisible && s['visible'])}>
        <DealerAd
          disableLazy
          className={s['unit']}
          realEstateId={realEstateId}
          extraParams={
            process.env.NODE_ENV === 'development'
              ? {
                  forcefixture: 'adhesion',
                }
              : {}
          }
        />
        <IconButton
          className={s['close']}
          aria-label="Hide Advertisment"
          icon={Close}
          size={'small'}
          onClick={closeHandler}
        />
      </div>
    </ErrorBoundary>
  );
};
AdhesionAdUnit.displayName = 'AdhesionAdUnit';

export default AdhesionAdUnit;
